import { Component, OnInit } from '@angular/core';
import { BaseReportActionsDialog } from '../base-report-actions-dialog';
import { GaValidateService } from '../../../formly/ga-validate.service';
import { GaFormlyService, IExtraFieldConfigurationObject } from '../../../formly/ga-formly.service';
import { ReportDataService } from '../../report-data.service';
import { GaEventService } from '../../../services/ga-event.service';
import { IObject } from '../../../../../type_definitions/datatypes';

@Component({
  selector: 'change-invoice-template-action',
  templateUrl: '../../../message/dialogs/default-form-dialog.html'
})
export class ChangeInvoiceTemplateActionComponent extends BaseReportActionsDialog implements OnInit {
  private invoiceTemplateField: IExtraFieldConfigurationObject;
  constructor(
    private formlyService: GaFormlyService,
    private reportDataService: ReportDataService,
    eventService: GaEventService,
    validateService: GaValidateService
  ) {
    super(eventService, validateService);
  }

  public ngOnInit(): void {
    super.ngOnInit();

    // create fields
    this.createFields();
    this.fillFields();
  }

  private createFields(): void {
    const invoiceTemplateChangeWarning: IExtraFieldConfigurationObject = this.formlyService.aTemplate(`
      <div class="alert alert-warning">
        <i class="fa fa-warning"></i> The changes made on the outgoing invoice template will only be applicable for order(s)/quote(s) for the webshop and the selected BPs
      </div>
    `)
      .withHideExpression(() => !!(this.actionDialogParams?.hideWorkflow))
      .build();

    this.invoiceTemplateField = this.formlyService.aSelect('invoiceTemplateId', 'Select invoice template')
      .isRequired()
      .isLoading()
      .withLabelProp('value')
      .withValueProp('id')
      .build();

    this.fields = [
      invoiceTemplateChangeWarning,
      this.invoiceTemplateField
    ];
  }

 private fillFields(): void {
    this.formlyService.fillField(this.invoiceTemplateField, this.reportDataService.loadReportActionInfo(this.reportId, this.action.id, this.rowSelection, true)
      .then((actionInfoData) => {
        return actionInfoData.info;
      })
      .catch((data:IObject) => {
        this.error = data?.message;
      }));
 }
}